export const appsManagerDictionary = [
  {
    key: 'invite',
    en: 'Invite',
    uk: 'Запросити',
    de: 'Einladen',
    fr: 'Inviter'
  },
  {
    key: 'send_invites',
    en: 'Send invites',
    uk: 'Надіслати запрошення',
    de: 'Einladungen senden',
    fr: 'Envoyer les invitations'
  },
  {
    key: 'cancel',
    en: 'Cancel',
    uk: 'Скасувати',
    de: 'Abbrechen',
    fr: 'Annuler'
  },
  {
    key: 'log_out',
    en: 'Log out',
    uk: 'Вийти',
    de: 'Abmelden',
    fr: 'Se déconnecter'
  },
  {
    key: 'settings',
    en: 'Settings',
    uk: 'Налаштування',
    de: 'Einstellungen',
    fr: 'Paramètres'
  },
  {
    key: 'account_settings',
    en: 'Account settings',
    uk: 'Налаштування акаунту',
    de: 'Kontoeinstellungen',
    fr: 'Paramètres du compte'
  },
  {
    key: 'change_password',
    en: 'Change Password',
    uk: 'Змінити пароль',
    de: 'Passwort ändern',
    fr: 'Changer le mot de passe'
  },
  {
    key: 'groups',
    en: 'Groups',
    uk: 'Групи',
    de: 'Gruppen',
    fr: 'Groupes'
  },
  {
    key: 'mcp_servers',
    en: 'MCP Servers',
    uk: 'MCP Сервери',
    de: 'MCP-Server',
    fr: 'Serveurs MCP'
  },
  {
    key: 'applications',
    en: 'Applications',
    uk: 'Застосунки',
    de: 'Anwendungen',
    fr: 'Applications'
  },
  {
    key: 'integrations',
    en: 'Integrations',
    uk: 'Інтеграції',
    de: 'Integrationen',
    fr: 'Intégrations'
  },
  {
    key: 'automations',
    en: 'Automations',
    uk: 'Автоматизації',
    de: 'Automatisierungen',
    fr: 'Automatisations'
  },
  {
    key: 'recycle_bin',
    en: 'Recycle Bin',
    uk: 'Кошик',
    de: 'Papierkorb',
    fr: 'Corbeille'
  },
  {
    key: 'first_name',
    en: 'First Name',
    uk: 'Ім\'я',
    de: 'Vorname',
    fr: 'Prénom'
  },
  {
    key: 'last_name',
    en: 'Last Name',
    uk: 'Прізвище',
    de: 'Nachname',
    fr: 'Nom de famille'
  },
  {
    key: 'email',
    en: 'Email',
    uk: 'Електронна пошта',
    de: 'E-Mail',
    fr: 'E-mail'
  },
  {
    key: 'language',
    en: 'Language',
    uk: 'Мова',
    de: 'Sprache',
    fr: 'Langue'
  },
  {
    key: 'update',
    en: 'Update',
    uk: 'Оновити',
    de: 'Aktualisieren',
    fr: 'Mettre à jour'
  },
  {
    key: 'new_password',
    en: 'New Password',
    uk: 'Новий пароль',
    de: 'Neues Passwort',
    fr: 'Nouveau mot de passe'
  },
  {
    key: 'confirm_password',
    en: 'Confirm Password',
    uk: 'Підтвердити пароль',
    de: 'Passwort bestätigen',
    fr: 'Confirmer le mot de passe'
  },
  {
    key: 'old_password',
    en: 'Old Password',
    uk: 'Старий пароль',
    de: 'Altes Passwort',
    fr: 'Ancien mot de passe'
  },
  {
    key: 'add',
    en: 'Add',
    uk: 'Додати',
    de: 'Hinzufügen',
    fr: 'Ajouter'
  },
  {
    key: 'name',
    en: 'Name',
    uk: 'Назва',
    de: 'Name',
    fr: 'Nom'
  },
  {
    key: 'permission',
    en: 'Permission',
    uk: 'Дозвіл',
    de: 'Berechtigung',
    fr: 'Permission'
  },
  {
    key: 'block',
    en: 'Block',
    uk: 'Блок',
    de: 'Blockieren',
    fr: 'Bloquer'
  },
  {
    key: 'read',
    en: 'Read',
    uk: 'Читання',
    de: 'Lesen',
    fr: 'Lire'
  },
  {
    key: 'write',
    en: 'Write',
    uk: 'Запис',
    de: 'Schreiben',
    fr: 'Écrire'
  },
  {
    key: 'admin',
    en: 'Admin',
    uk: 'Адмін',
    de: 'Admin',
    fr: 'Admin'
  },
  {
    key: 'deleting_application',
    en: 'Deleting Application!',
    uk: 'Видалення застосунку!',
    de: 'Anwendung löschen!',
    fr: 'Suppression de l\'application !'
  },
  {
    key: 'delete_app_confirmation',
    en: 'Do you really want to delete this application?',
    uk: 'Ви дійсно хочете видалити цей застосунок?',
    de: 'Möchten Sie diese Anwendung wirklich löschen?',
    fr: 'Voulez-vous vraiment supprimer cette application ?'
  },
  {
    key: 'delete',
    en: 'Delete',
    uk: 'Видалити',
    de: 'Löschen',
    fr: 'Supprimer'
  },
  {
    key: 'blocked',
    en: 'Blocked',
    uk: 'Заблокований',
    de: 'Blockiert',
    fr: 'Bloqué'
  },
  {
    key: 'member',
    en: 'Member',
    uk: 'Учасник',
    de: 'Mitglied',
    fr: 'Membre'
  },
  {
    key: 'owner',
    en: 'Owner',
    uk: 'Власник',
    de: 'Eigentümer',
    fr: 'Propriétaire'
  },
  {
    key: 'no_members',
    en: 'No Members',
    uk: 'Немає учасників',
    de: 'Keine Mitglieder',
    fr: 'Aucun membre'
  },
  {
    key: 'no_applications',
    en: 'No Applications',
    uk: 'Немає застосунків',
    de: 'Keine Anwendungen',
    fr: 'Aucune application'
  },
  {
    key: 'no_groups',
    en: 'No Groups',
    uk: 'Немає груп',
    de: 'Keine Gruppen',
    fr: 'Aucun groupe'
  },
  {
    key: 'deleting_member',
    en: 'Deleting Member!',
    uk: 'Видалення учасника!',
    de: 'Mitglied löschen!',
    fr: 'Suppression du membre !'
  },
  {
    key: 'delete_member_confirmation',
    en: 'Do you really want to delete this member?',
    uk: 'Ви дійсно хочете видалити цього учасника?',
    de: 'Möchten Sie dieses Mitglied wirklich löschen?',
    fr: 'Voulez-vous vraiment supprimer ce membre ?'
  },
  {
    key: 'deleting_group',
    en: 'Deleting Group!',
    uk: 'Видалення групи!',
    de: 'Gruppe löschen!',
    fr: 'Suppression du groupe !'
  },
  {
    key: 'delete_group_confirmation',
    en: 'Do you really want to delete group? You will not be able to restore it.',
    uk: 'Ви дійсно хочете видалити групу? Відновити її буде неможливо.',
    de: 'Möchten Sie die Gruppe wirklich löschen? Sie kann nicht wiederhergestellt werden.',
    fr: 'Voulez-vous vraiment supprimer ce groupe ? Vous ne pourrez pas le restaurer.'
  },
  {
    key: 'administrators',
    en: 'Administrators:',
    uk: 'Адміністратори:',
    de: 'Administratoren:',
    fr: 'Administrateurs :'
  },
  {
    key: 'members',
    en: 'Members',
    uk: 'Учасники',
    de: 'Mitglieder',
    fr: 'Membres'
  },
  {
    key: 'deleting_integration!',
    en: 'Deleting Integration!',
    uk: 'Видалення інтеграції!',
    de: 'Integration löschen!',
    fr: 'Suppression de l\'intégration !'
  },
  {
    key: 'do_you_really_want_to_delete',
    en: 'Do you really want to delete',
    uk: 'Ви дійсно хочете видалити',
    de: 'Möchten Sie wirklich löschen',
    fr: 'Voulez-vous vraiment supprimer'
  },
  {
    key: 'general',
    en: 'General',
    uk: 'Загальні',
    de: 'Allgemein',
    fr: 'Général'
  },
  {
    key: 'password',
    en: 'Password',
    uk: 'Пароль',
    de: 'Passwort',
    fr: 'Mot de passe'
  },
  {
    key: 'account',
    en: 'Account',
    uk: 'Акаунт',
    de: 'Konto',
    fr: 'Compte'
  },
  {
    key: 'all_data_related_to_this_account_will_be_removed',
    en: 'All data related to this account will be removed',
    uk: 'Усі дані, пов’язані з цим акаунтом, буде видалено',
    de: 'Alle Daten zu diesem Konto werden gelöscht',
    fr: 'Toutes les données liées à ce compte seront supprimées'
  },
  {
    key: 'delete_account',
    en: 'Delete Account',
    uk: 'Видалити акаунт',
    de: 'Konto löschen',
    fr: 'Supprimer le compte'
  },
  {
    key: 'this_action_cannot_be_undone',
    en: 'This action cannot be undone',
    uk: 'Цю дію неможливо скасувати',
    de: 'Diese Aktion kann nicht rückgängig gemacht werden',
    fr: 'Cette action est irréversible'
  },
  {
    key: 'are_you_sure_you_want_to_delete_your_account',
    en: 'Are you sure you want to delete your account',
    uk: 'Ви впевнені, що хочете видалити свій акаунт',
    de: 'Möchten Sie Ihr Konto wirklich löschen',
    fr: 'Êtes-vous sûr de vouloir supprimer votre compte'
  },
  {
    key: 'email_does_not_match',
    en: 'Email does not match',
    uk: 'Електронна пошта не збігається',
    de: 'E-Mail-Adresse stimmt nicht überein',
    fr: 'L\'e-mail ne correspond pas'
  },
  {
    key: 'type_your_email_to_confirm',
    en: 'Type your email to confirm',
    uk: 'Введіть свою електронну пошту для підтвердження',
    de: 'Geben Sie Ihre E-Mail-Adresse zur Bestätigung ein',
    fr: 'Saisissez votre e-mail pour confirmer'
  },
  {
    key: 'integration?',
    en: 'integration?',
    uk: 'інтеграцію?',
    de: 'Integration?',
    fr: 'l\'intégration ?'
  },
  {
    key: 'add_group',
    en: 'Add group',
    uk: 'Додати групу',
    de: 'Gruppe hinzufügen',
    fr: 'Ajouter un groupe'
  },
  {
    key: 'group_name',
    en: 'Group name',
    uk: 'Назва групи',
    de: 'Gruppenname',
    fr: 'Nom du groupe'
  },
  {
    key: 'mcp_server_info',
    en: 'MCP Server Info',
    uk: 'Інфо MCP Сервера',
    de: 'MCP-Server-Info',
    fr: 'Info serveur MCP'
  },
  {
    key: 'name:',
    en: 'Name:',
    uk: 'Назва:',
    de: 'Name:',
    fr: 'Nom :'
  },
  {
    key: 'application:',
    en: 'Application:',
    uk: 'Застосунок:',
    de: 'Anwendung:',
    fr: 'Application :'
  },
  {
    key: 'loading_applications…',
    en: 'Loading applications…',
    uk: 'Завантаження застосунків…',
    de: 'Anwendungen werden geladen…',
    fr: 'Chargement des applications…'
  },
  {
    key: 'select_application…',
    en: 'Select application…',
    uk: 'Оберіть застосунок…',
    de: 'Anwendung auswählen…',
    fr: 'Sélectionner une application…'
  },
  {
    key: 'field:',
    en: 'Field:',
    uk: 'Поле:',
    de: 'Feld:',
    fr: 'Champ :'
  },
  {
    key: 'loading_fields…',
    en: 'Loading fields…',
    uk: 'Завантаження полів…',
    de: 'Felder werden geladen…',
    fr: 'Chargement des champs…'
  },
  {
    key: 'select_field…',
    en: 'Select field…',
    uk: 'Оберіть поле…',
    de: 'Feld auswählen…',
    fr: 'Sélectionner un champ…'
  },
  {
    key: 'select_application_first…',
    en: 'Select application first…',
    uk: 'Спочатку оберіть застосунок…',
    de: 'Zuerst Anwendung auswählen…',
    fr: 'Sélectionner d\'abord une application…'
  },
  {
    key: 'no_fields_found_in_selected_application',
    en: 'No fields found in selected application',
    uk: 'Полів у вибраному застосунку не знайдено',
    de: 'Keine Felder in der ausgewählten Anwendung gefunden',
    fr: 'Aucun champ trouvé dans l\'application sélectionnée'
  },
  {
    key: 'active:',
    en: 'Active:',
    uk: 'Активний:',
    de: 'Aktiv:',
    fr: 'Actif :'
  },
  {
    key: 'copy',
    en: 'Copy',
    uk: 'Копіювати',
    de: 'Kopieren',
    fr: 'Copier'
  },
  {
    key: 'copied!',
    en: 'Copied!',
    uk: 'Скопійовано!',
    de: 'Kopiert!',
    fr: 'Copié !'
  },
  {
    key: 'copy_url',
    en: 'Copy URL',
    uk: 'Копіювати URL',
    de: 'URL kopieren',
    fr: 'Copier l\'URL'
  },
  {
    key: 'copied',
    en: 'Copied',
    uk: 'Скопійовано',
    de: 'Kopiert',
    fr: 'Copié'
  },
  {
    key: 'external_function',
    en: 'External Function',
    uk: 'Зовнішня функція',
    de: 'Externe Funktion',
    fr: 'Fonction externe'
  },
  {
    key: 'edit',
    en: 'Edit',
    uk: 'Редагувати',
    de: 'Bearbeiten',
    fr: 'Modifier'
  },
  {
    key: 'save',
    en: 'Save',
    uk: 'Зберегти',
    de: 'Speichern',
    fr: 'Enregistrer'
  },
  {
    key: 'loading_external_functions…',
    en: 'Loading external functions…',
    uk: 'Завантаження зовнішніх функцій…',
    de: 'Externe Funktionen werden geladen…',
    fr: 'Chargement des fonctions externes…'
  },
  {
    key: 'select_external_function…',
    en: 'Select external function…',
    uk: 'Оберіть зовнішню функцію…',
    de: 'Externe Funktion auswählen…',
    fr: 'Sélectionner une fonction externe…'
  },
  {
    key: 'no_items_found_for_selected_application_and_field',
    en: 'No items found for selected application and field',
    uk: 'Елементів для вибраного застосунку та поля не знайдено',
    de: 'Keine Einträge für die ausgewählte Anwendung und das Feld gefunden',
    fr: 'Aucun élément trouvé pour l\'application et le champ sélectionnés'
  },
  {
    key: 'apply',
    en: 'Apply',
    uk: 'Застосувати',
    de: 'Anwenden',
    fr: 'Appliquer'
  },
  {
    key: 'no_external_functions',
    en: 'No External Functions',
    uk: 'Немає зовнішніх функцій',
    de: 'Keine externen Funktionen',
    fr: 'Aucune fonction externe'
  },
  {
    key: 'add_mcp_server',
    en: 'Add MCP Server',
    uk: 'Додати MCP Сервер',
    de: 'MCP-Server hinzufügen',
    fr: 'Ajouter un serveur MCP'
  },
  {
    key: 'server_name',
    en: 'Server name',
    uk: 'Назва сервера',
    de: 'Servername',
    fr: 'Nom du serveur'
  },
  {
    key: 'english',
    en: 'English',
    uk: 'Англійська',
    de: 'Englisch',
    fr: 'Anglais'
  },
  {
    key: 'ukrainian',
    en: 'Ukrainian',
    uk: 'Українська',
    de: 'Ukrainisch',
    fr: 'Ukrainien'
  },
  {
    key: 'german',
    en: 'German',
    uk: 'Німецька',
    de: 'Deutsch',
    fr: 'Allemand'
  },
  {
    key: 'french',
    en: 'French',
    uk: 'Французька',
    de: 'Französisch',
    fr: 'Français'
  },
  {
    key: 'task',
    en: 'Task',
    uk: 'Завдання',
    de: 'Aufgabe',
    fr: 'Tâche'
  },
  {
    key: 'trigger',
    en: 'Trigger',
    uk: 'Тригер',
    de: 'Auslöser',
    fr: 'Déclencheur'
  },
  {
    key: 'api',
    en: 'Api',
    uk: 'Api',
    de: 'Api',
    fr: 'Api'
  },
  {
    key: 'elements',
    en: 'Elements',
    uk: 'Елементи',
    de: 'Elemente',
    fr: 'Éléments'
  },
  {
    key: 'application',
    en: 'Application',
    uk: 'Застосунок',
    de: 'Anwendung',
    fr: 'Application'
  },
  {
    key: 'status',
    en: 'Status',
    uk: 'Статус',
    de: 'Status',
    fr: 'Statut'
  },
  {
    key: 'scheduling',
    en: 'Scheduling',
    uk: 'Розклад',
    de: 'Planung',
    fr: 'Planification'
  },
  {
    key: 'created_items',
    en: 'Created Items',
    uk: 'Створені елементи',
    de: 'Erstellte Einträge',
    fr: 'Éléments créés'
  },
  {
    key: 'deleted_items',
    en: 'Deleted Items',
    uk: 'Видалені елементи',
    de: 'Gelöschte Einträge',
    fr: 'Éléments supprimés'
  },
  {
    key: 'updated_items',
    en: 'Updated Items',
    uk: 'Оновлені елементи',
    de: 'Aktualisierte Einträge',
    fr: 'Éléments mis à jour'
  },
  {
    key: 'updated_file',
    en: 'Updated File',
    uk: 'Оновлений файл',
    de: 'Aktualisierte Datei',
    fr: 'Fichier mis à jour'
  },
  {
    key: 'updated_value',
    en: 'Updated Value',
    uk: 'Оновлене значення',
    de: 'Aktualisierter Wert',
    fr: 'Valeur mise à jour'
  },
  {
    key: 'active',
    en: 'Active',
    uk: 'Активний',
    de: 'Aktiv',
    fr: 'Actif'
  },
  {
    key: 'no_mcp_servers',
    en: 'No MCP Servers',
    uk: 'Немає MCP Серверів',
    de: 'Keine MCP-Server',
    fr: 'Aucun serveur MCP'
  },
  {
    key: 'server_url_will_be_generated_automatically.',
    en: 'Server URL will be generated automatically.',
    uk: 'URL сервера буде згенеровано автоматично.',
    de: 'Die Server-URL wird automatisch generiert.',
    fr: 'L\'URL du serveur sera générée automatiquement.'
  },
];
